import React from "react";
import HomeView from "./HomeView";
import { graphql, QueryRenderer } from "react-relay";
import environment from "./Environment";
import { GC_USER_ID } from "./constants";
import { commitLocalUpdate } from "react-relay";
import { createOperationDescriptor, getRequest } from "relay-runtime";
import Spinner from "./Spinner";
import ThemeProvider from "./contexts/ThemeContext";

const userDetailsQuery = graphql`
	query HomeViewWrapper_UserDetails_Query($id: ID!) {
		user(id: $id) {
			email
            currency
			is_premium
			is_active
            has_active_payment
            payment_status
            first_time_user
		}
		settings {
			isAuthenticated
			userId
			isNavActivated
            isRightNavActivated
			isFullScreenMenuActivated
			selectedSourceId
			selectedParentId
			treeStates
			selectedNodeId
			isParent
			selectedLeads
            selectedSentimentPostIds
			filterTerms
			isNoteViewActivated
			isDetailView
			metaSourceName
			metaDescription
			scrollPosition
			isHomeReturn
			isBookmarkView
			isPostNoteView
			isNewFolderView
			isFullSpanSearchModalActivated
			isFullSpanNoteModalActivated
			isFullSpanShareModalActivated
			isFullSpanInputModalActivated
            isProductDemoActivated
            isAnalyseModalActivated
            isAddSourcePageActivated

			isAdvancedSearch	
			hasPhrase
			withoutWords
			withWords
			searchScope
			searchTime
			allSubscriptions
            view
            order

            selectedAnayzeTitle
            selectedAnalyzePostId
		}
	}
`;

const request = getRequest(userDetailsQuery);
const operation = createOperationDescriptor(request, {} /* variables */);

function createAuthDetails(id) {
	commitLocalUpdate(environment, store => {
		const record = store.getRoot().getLinkedRecord("settings");
		record.setValue(true, "isAuthenticated");
		record.setValue(id, "userId");
	});
}

function HomeViewWrapper(props) {
	let userId = localStorage.getItem(GC_USER_ID);
	createAuthDetails(userId);

	// useEffect(() => {
	// 	console.log("UserId from HomeViewWrapper(from useEffect): " + userId);
	// 	return () => {
	// 		// localStorage.removeItem(GC_USER_ID);
	// 		// localStorage.removeItem(GC_AUTH_TOKEN);
	// 	};
	// });

	return (
		<QueryRenderer
			environment={environment}
			fetchPolicy={"store-and-network"}
			query={userDetailsQuery}
			variables={{ id: userId }}
			render={({ error, props }) => {
				if (error) throw error;
				if (!props)
					return (
						<div>
							{" "}
							<Spinner isLoading={true} />{" "}
						</div>
					);
				return (
					<div>
						<ThemeProvider>
							<HomeView user={props.user} settings={props.settings} />
						</ThemeProvider>
					</div>
				);
			}}
		/>
	);
}

export default HomeViewWrapper;
